<template>
  <div class="sf-charteditor-wrapper">
    <graph-navbar></graph-navbar>
    <div class="sf-charteditor">
      <div class="sf-charteditor-left">
        <title-and-type></title-and-type><graph-values-list></graph-values-list
        ><maximum-and-minimum-values></maximum-and-minimum-values>
      </div>
      <div class="sf-charteditor-right">
        <xaxis-selector></xaxis-selector>
        <div class="sf-pad-2">
          <sf-preview></sf-preview><sf-description></sf-description>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SfDescription from './sf-description.vue'
import GraphValuesList from './graph-values-list.vue'
import MaximumAndMinimumValues from './maximum-and-minimum-values.vue'
import GraphNavbar from './graph-navbar'
import SfPreview from './sf-preview.vue'
import TitleAndType from './title-and-type.vue'
import XaxisSelector from './xaxis-selector.vue'

const ReportGraphEditor = {
  components: {
    SfDescription,
    GraphValuesList,
    MaximumAndMinimumValues,
    GraphNavbar,
    SfPreview,
    TitleAndType,
    XaxisSelector,
  },
}

export default ReportGraphEditor
</script>
